<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid2Col">
	<!--INSERT CUSTOM POPUP FIELDS-->
	<label>Name:</label>
	<input [disabled]="IsLoading() == true" class="form-control" type="text" placeholder="" [(ngModel)]="AcademyDesc" />

	<label>Abbreviation:</label>
	<input [disabled]="IsLoading() == true" class="form-control" type="text" placeholder="" [(ngModel)]="AcademyCD" />

	<label>Administrator:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="DirectorID" [(ngModel)]="SelectedStaff">
		<option *ngFor="let r of lstStaff" [ngValue]="r">{{ r.StaffFullName }}</option>
	</select>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" class="btn btn-primary" (click)="onEditAcademy()">Update</button>
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
